export default __webpack_public_path__ + "static/media/PosterMB-4.7f219859.JPG";